<template>
  <div class="multiple-select-box">
    <div class="cur-name" :style="containerStyleObj" :class="{'cur-name-active': isShow}" v-popover:popoverSelect>
      <div v-if="config.isShowAllItem" class="cur-name-text all-item-box">
        <span class="all-item" v-show="!config.value.length">{{config.placeholder}}</span>
        <span class="tx-hide one-ellipsis all-item" v-for="(id, index) in config.value" :key="id">
          <span>{{showName(id)}}</span>
          <i class="el-icon-close ml05" @click="removeItem(index)" />
        </span>
      </div>
      <div v-else class="cur-name-text">
        <span class="tx-hide" :class="{'one-ellipsis': config.value.length}">{{selectValue}}</span>
        <span class="one-ellipsis ml05" v-show="config.value.length > 1">+ {{config.value.length - 1}}</span>
      </div>
      <i class="el-icon-arrow-up arrow" :class="{isReverse: isShow, isValue: config.value.length}" />
      <i v-if="config.value.length" class="el-icon-error close" @click.stop="removeAll"/>
    </div>
    <!-- 下拉弹框 -->
    <el-popover v-model="isShow"
      ref="popoverSelect"
      popper-class="select-popover"
      placement="bottom-start"
      trigger="click">
        <div class="select-popover-main">
          <!-- 搜索 -->
          <div class="search-module clearfix" v-if="!config.isHideFilter && (isRemoteSearch || config.options.length)">
            <el-input placeholder="搜索内容" v-model="searchText" />
          </div>
          <!-- checkbox Group -->
          <div class="list-box" v-show="itemlist.length">
            <el-checkbox v-model="checkAll" @change="handleCheckedAll">全选</el-checkbox>
            <el-checkbox-group v-model="selectData" @change="handleCheckedChange">
              <el-checkbox v-for="item in itemlist" :label="item.id" :key="item.id">{{item.name}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div class="tip-nodata" v-if="!isRemoteSearch && !config.options.length">暂无数据</div>
          <div class="tip-nodata" v-else-if="isNoData">无搜索结果</div>
          <div class="select-footer">
            <el-button style="height:auto" size="mini" type="text" @click="handleClickClose">取消</el-button>
            <el-button style="height:auto" type="primary" size="mini" @click="handleClickSaveTemplateBtn">确定</el-button>
          </div>
        </div>
        <div class="select-popover-shodow" @click="isShow = false"></div>
    </el-popover>
  </div>
</template>

<script>
import { deepCopy } from '@/utils/deep-copy'
import debounce from 'lodash/debounce'
import { isNullOrUndefinedOrEmptyStr } from '@/services/utils/modules/base'

export default {
  data() {
    return {
      selectValue: '',
      isShow: false, // 下拉框是否显示
      isCancelClose: false, // 是否手动取消关闭
      // isNoData: false, // 是否无数据,改为使用 computed
      searchText: '', // 搜索词
      itemlist: [], // 搜索过的下拉选项
      selectData: [], // 选中的数据
      checkAll: false // 是否全选
    }
  },
  props: {
    config: {
      type: Object,
      default: null
    },
    height: {
      type: [String, Number],
      default: 32
    }
  },
  computed: {
    isNoData() {
      // 搜索结果无数据
      return !this.itemlist || this.itemlist.length === 0
    },
    // 是否是远程搜索
    isRemoteSearch() {
      return this.config.remote && this.config.remoteMethod
    },
    containerStyleObj() {
      const ret = {
        minHeight: this.height + 'px',
      }

      // 判断是否需要增加宽度
      if (!isNullOrUndefinedOrEmptyStr(this.config.width)) {
        ret.width = this.config.width
      }

      return ret
    },
  },
  watch: {
    isShow(val) {
      if (val) {
        this.init()
      } else {
        this.$emit('blur')
        !this.isCancelClose && this.handleClickSaveTemplateBtn()
      }
    },
    searchText(newVal, oldVal) { // 搜索框实时检索
      this.search(newVal.trim())
    },
    config: { // 选项列表变化时
      handler: function(newVal, oldVal) {
        this.initValue()
      },
      deep: true,
      immediate: true
    },
    // 'config.options'(newVal) {
    //   this.config.value = this.config.value.filter(value => {
    //     const findIndex = newVal.findIndex(item => item.id === value)
    //     return findIndex > -1
    //   })
    // },
    itemlist(val) {
      for (var i = 0; i < val.length; i++) {
        const findIndex = this.selectData.findIndex(item => item === val[i].id)
        if (findIndex === -1) {
          this.checkAll = false
          return
        }
      }
      this.checkAll = true
    },
  },
  methods: {
    init() { // 初始化数据
      this.searchText = ''
      this.isCancelClose = false
      this.selectData = deepCopy(this.config.value) || []
      this.itemlist = this.config.options
    },
    initValue() { // 初始选中值回显
      if (this.config.value.length > 0) {
        const valueFirst = this.config.options.find(option => option.id === this.config.value[0])
        if (valueFirst) {
          this.selectValue = valueFirst.name
          return
        }
      }
      this.selectValue = this.config.placeholder || '请选择'

      // todo 待优化, 是否全选, 跟value options 计算出来
      // 这里的场景稍微复杂 this.config.value  this.config.options  this.selectData this.itemList
      const { value: configValue } = this.config
      if (!configValue || configValue.length === 0) {
        this.selectData = []
        this.checkAll = false
      }
    },
    showName(id) {
      const findObj = this.config.options.find(option => option.id === id)
      if (findObj) return findObj.name
      return ''
    },
    search: debounce(async function(val) { // 搜索事件
      if (!this.isRemoteSearch) {
        const reg = new RegExp(val, 'i')
        // 本地搜索逻辑
        if (val) {
          this.itemlist = this.config.options.filter(item => {
            return item.name.match(reg)
          })
        } else {
          this.itemlist = this.config.options
        }
      } else {
        // 远程搜索逻辑
        this.itemlist = await this.config.remoteMethod(val)
      }
    }, 300),
    handleClickClose() {
      this.isCancelClose = true
      this.isShow = false
    },
    handleClickSaveTemplateBtn() {
      if (JSON.stringify(this.config.value) !== JSON.stringify(this.selectData)) {
        this.config.value = this.selectData
        this.$emit('change', this.config)
      }
      this.handleClickClose()
    },
    removeItem(index) { // 删除mouge
      this.config.value.splice(index, 1)
    },
    removeAll() { // 删除全部
      this.config.value = []
      this.$emit('change', this.config)
      this.checkAll = false
      this.handleClickClose()
    },
    handleCheckedChange(val) {
      for (var i = 0; i < this.itemlist.length; i++) {
        const findIndex = val.findIndex(item => item === this.itemlist[i].id)
        if (findIndex === -1) {
          this.checkAll = false
          return
        }
      }
      this.checkAll = true
    },
    handleCheckedAll(val) {
      if (val) {
        // 全选
        const arr = this.itemlist.map(item => {
          return item.id
        })
        this.selectData = [...new Set([...this.selectData, ...arr])]
      } else {
        // 取消全选
        this.selectData = this.selectData.filter(item => {
          const findIndex = this.itemlist.findIndex(k => k.id === item)
          if (findIndex >= 0) {
            return false
          }
          return true
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.cur-name {
  min-width: 120px;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  position: relative;
  box-sizing: border-box;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  height: 100%;
  border: 1px solid $G4;
  border-radius: 2px;
  color: $main-text-color;
  cursor: pointer;
  font-size: 12px;
  .cur-name-text{
    flex: 1;
    color: $G7;
    overflow: hidden;
    display: flex;
    line-height: 16px;
    .one-ellipsis{
      padding: 0 4px;
      border-radius: 2px;
      background-color: $G3;
      color: $main-text-color;
      white-space: nowrap;
    }
    .ml05{
      margin-left: 5px;
    }
    &.all-item-box{
      flex-wrap: wrap;
      margin-top: -5px;
      margin-right: -5px;
      .all-item{
        margin-top: 5px;
        margin-right: 5px;
        .el-icon-close{
          font-size: 10px;
          position: relative;
          z-index: 5;
          color: $G7;
          &:hover{
            color: $G9;
          }
        }
      }
    }
  }
  .arrow{
    padding: 1px;
    width: 14px;
    font-size: 14px;
    margin-left: 5px;
    color:#C0C4CC;
    transition: transform .3s;
    transform: rotate(180deg);
  }
  .isReverse{
    width: 14px;
    font-size: 14px;
    color:#C0C4CC;
    transform: rotate(0deg);
  }
  .close{
    font-size: 14px;
    color: #C1C0CC;
    margin-left: 5px;
    display: none;
    &:hover{
      color: #9D9C9E;
    }
  }
  &:hover{
    border-color: #C0C4CC;
    .isValue{
      display: none;
    }
    .close{
      display: block;
    }
  }
}
.cur-name-active{
  border: 1px solid $main-color;
}
.search-module{
  padding: 4px 8px;
  ::v-deep .el-input__inner{
    border-top: none;
    border-left: none;
    border-right: none;
    padding-left: 0;
    padding-right: 0;
    border-radius: 0;
  }
}
.list-box{
  max-height: 300px;
  overflow-y: auto;
}
.tip-nodata {
  padding: 20px 0 10px;
  text-align: center;
  font-size: 13px;
  color: #bbbbbb;
}
::v-deep .el-checkbox{
  margin: 0;
  padding: 0 10px;
  line-height: 36px;
  display: block;
  &:hover{
    background-color: #f7f8fa;
  }
}
.select-footer{
  margin-top: 10px;
  padding: 5px 8px;
  box-shadow: 0 -2px 4px 0 rgb(0 0 0 / 3%);
  display: flex;
  justify-content: flex-end;
}
.el-popover.el-popper .el-button--primary{
  font-size: 12px;
}
.el-popover.el-popper .el-button--mini.el-button--text{
  font-size: 12px;
  border: 1px solid $G7;
  &:hover{
    border-color: $main-color;
  }
}
.select-popover-main{
  position: relative;
  z-index: 2;
  background: #ffffff;
}
.select-popover-shodow{
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  width: 100vw;
  height:100vh;
}
</style>
